let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4p1M4")).then(() => parcelRequire('7vChv'));